import React, { ButtonHTMLAttributes } from "react";
import "./Button.scss";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'major-alpha' | "hollow"
    icon?: 'arrow-right'
}

export function Button(props: IProps) {
    const {
        variant = 'primary',
        className: originalClassName = '',
        children,
        icon,
        ...buttonProps
    } = props;

    const className = originalClassName.split(' ');
    className.push('button');
    className.push(`variant-${variant}`)

    let iconAfter;
    if (icon) {
        className.push('has-icon-after');
        iconAfter = <svg xmlns="http://www.w3.org/2000/svg" width="56.931" height="42.698" viewBox="0 0 56.931 42.698">
            <path id="noun_Arrow_1920786_000000" d="M57.627,29.807,41.551,14.483a6.559,6.559,0,0,0-8.938,0,5.841,5.841,0,0,0,0,8.52l5.279,5.032H8.8a6.011,6.011,0,1,0,0,12.007H37.952l-5.339,5.089a5.841,5.841,0,0,0,0,8.52,6.332,6.332,0,0,0,4.439,1.773,6.23,6.23,0,0,0,4.439-1.773L57.567,38.327a5.792,5.792,0,0,0,1.86-4.231A5.473,5.473,0,0,0,57.627,29.807Z" transform="translate(-2.5 -12.725)"/>
        </svg>
    }

    return <button className={className.join(' ').trim()}
                   {...buttonProps}><span>{children}</span>{iconAfter}</button>
}
